import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { validators } from '../../utils/helpers/validators'
import CompaniesService from '../../services/companies/companies.service'
import MutualsService from '../../services/mutuals/mutuals.service'
import useInputs from '../../utils/hooks/useInputs'
import { companiesPathname } from '../../routes/settings/pathname'
import LabeledDropdown from '../common/form-components/labeled-dropdown/LabeledDropdown'
import SaveButton from '../common/buttons/SaveButton'
import LabeledText from '../common/form-components/labeled-inputs/LabeledText'
import './companyForm.scss'

const CompanyForm = ({ companyId, submit }) => {
  const navigate = useNavigate()

  const { inputs, updateInputs, onChangeInputs } = useInputs()

  const [mutuals, setMutuals] = useState([])

  useEffect(() => {
    getAllMutuals()
    if (companyId !== undefined) {
      getCompany()
    }
  }, [])

  const getCompany = async () => {
    const response = await CompaniesService.getById(companyId)
    if (response) {
      updateInputs(response.resp)
      return
    }
    navigate(companiesPathname.COMPANIES)
  }

  const getAllMutuals = async () => {
    const response = await MutualsService.getAll({})
    if (response) {
      setMutuals(response.resp)
    }
  }

  const validateForm =
    validators.hasValue(inputs?.name) &&
    validators.hasValue(inputs?.mutual) &&
    validators.hasValue(inputs?.nif) &&
    validators.hasValue(inputs?.sageCode)

  return (
    <div className="add-companies-container">
      <div className="modal-content-wrapper">
        <LabeledText
          idLabel="name"
          required
          name="name"
          value={inputs?.name}
          type="text"
          onChange={(e) => onChangeInputs(e)}
        />
        <LabeledText
          idLabel="NIF"
          required
          name="nif"
          value={inputs?.nif}
          type="text"
          onChange={(e) => onChangeInputs(e)}
        />
      </div>
      <div className="modal-content-wrapper">
        <LabeledText
          idLabel="sageCode"
          required
          name="sageCode"
          value={inputs?.sageCode}
          type="text"
          onChange={(e) => onChangeInputs(e)}
        />
        <LabeledDropdown
          idLabel="mutual"
          required
          name="mutual"
          value={inputs?.mutual}
          options={mutuals}
          optionLabel="name"
          optionValue="_id"
          onChange={(e) => onChangeInputs(e)}
        />
      </div>
      <div className="modal-content-wrapper">
        <LabeledText
          idLabel="account1"
          name="account1"
          value={inputs?.account1}
          type="text"
          onChange={(e) => onChangeInputs(e)}
        />
        <LabeledText
          idLabel="account2"
          name="account2"
          value={inputs?.account2}
          type="text"
          onChange={(e) => onChangeInputs(e)}
        />
      </div>
      <div className="modal-btn-container">
        <SaveButton
          btnClass="btn-save-modal"
          isDisabled={!validateForm}
          onClick={() => submit(inputs)}
        />
      </div>
    </div>
  )
}

export default CompanyForm
